import React, { useEffect, useState } from "react";
import inclogo from "../../../assets/images/inc-name-logo.png";
import eyeIcon from "../../../assets/images/eye-open.svg";
import eyeCloseIcon from "../../../assets/images/eye-close.svg";
import { useLocalization } from "../localization/LocalizationContext";
import ReactCountryFlag from "react-country-flag";
import allApi from "../../../api/allApi";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const countryOptions = [
  { code: "IN", name: "India" },
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "JP", name: "Japan" },
  { code: "CN", name: "China" },
  { code: "BR", name: "Brazil" },
  { code: "ZA", name: "South Africa" },
  { code: "RU", name: "Russia" },
  { code: "IT", name: "Italy" },
  { code: "ES", name: "Spain" },
  { code: "MX", name: "Mexico" },
  { code: "SG", name: "Singapore" },
  { code: "KR", name: "South Korea" },
  { code: "AE", name: "UAE" },
  { code: "NL", name: "Netherlands" },
  { code: "SE", name: "Sweden" },
];

const LicenseProfile = () => {
  const { localizationStrings } = useLocalization();
  const [step, setStep] = useState(1);
  const [orgName, setOrgName] = useState("");
  const [orgAddress, setOrgAddress] = useState("");
  const [orgCity, setOrgCity] = useState("");
  const [orgState, setOrgState] = useState("");
  const [orgCountry, setOrgCountry] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [userCity, setUserCity] = useState("");
  const [userState, setUserState] = useState("");
  const [userCountry, setUserCountry] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [networkName, setNetworkName] = useState("");
  const [networkCountry, setNetworkCountry] = useState("");
  const [deviceLimit, setDeviceLimit] = useState();
  const [networkLocation, setNetworkLocation] = useState("");
  const [networkTimezone, setNetworkTimezone] = useState("");
  const [networkStatus, setNetworkStatus] = useState("");
  const [dummyUserEmail, setDummyUserEmail] = useState("");
  const [timeZones, setTimeZones] = useState([]);


  const navigate = useNavigate();

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword((prev) => !prev);

  const handleNext = () => {
    setStep((prev) => Math.min(prev + 1, 3));
  };

  const handleBack = () => {
    setStep((prev) => Math.max(prev - 1, 1));
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(emailRegex.test(value) ? "" : "Invalid email format");
  };

  const fetchTimeZones = async () => {
  try {
    const api = new allApi();
    const response = await api.getRequest("api/network/timeZone");

    if (
      response?.status === "OK" &&
      Array.isArray(response?.response)
    ) {
      setTimeZones(response.response);
    } else {
      setTimeZones([]);
    }
  } catch (error) {
    console.error("Error fetching time zones:", error);
    setTimeZones([]);
  }
};

useEffect(() => {
  fetchTimeZones();
  const dummyUserEmail = localStorage.getItem("email");
  setDummyUserEmail(dummyUserEmail);
}, []);

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const payload = {
        organizationName: orgName,
        organizationAddress: orgAddress,
        organizationCity: orgCity,
        organizationState: orgState,
        organizationCountry: selectedOrg?.name || "",
        userName: username,
        userEmail: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        address: userAddress,
        state: userState,
        country: selectedUser?.name || "",
        networkName: networkName,
        networkCountry: networkCountry,
        device_limit: parseInt(deviceLimit, 10),
        network_location: networkLocation,
        network_timezone: networkTimezone,
        nwStatus: networkStatus,
        dummyUserEmail: dummyUserEmail,
      };
      const api = new allApi();
      const response = await api.postRequest("api/user/register", "", payload);

      if (response && response.success) {
        setShowSuccessModal(true);
        console.log("API Response:");
      }
    } catch (error) {
      console.error("Network Error:", error);
    }
  };

  const selectedOrg = countryOptions.find((c) => c.code === orgCountry);
  const selectedUser = countryOptions.find((c) => c.code === userCountry);

  const isOrgFormValid =
    orgName.trim() &&
    orgAddress.trim() &&
    orgCity.trim() &&
    orgState.trim() &&
    orgCountry.trim();

  const isUserFormValid =
    firstName.trim() &&
    lastName.trim() &&
    username.trim() &&
    email.trim() &&
    !emailError &&
    password.trim() &&
    confirmPassword.trim() &&
    password === confirmPassword &&
    userAddress.trim() &&
    userCity.trim() &&
    userState.trim() &&
    userCountry.trim();

  const isNetworkFormValid =
    networkName.trim() &&
    networkCountry.trim() &&
    deviceLimit &&
    networkLocation.trim() &&
    networkTimezone.trim() &&
    networkStatus.trim();

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    navigate("/");
  };

  return (
    <section className="inc-login">
      <div className="login-form">
        <div className="login-form-container userprofile">
          <div className="login-text">
            <img src={inclogo} alt="inc logo" className="inc-logo" />
            <h1>{localizationStrings?.licenseProfile}</h1>
            <div className="inc-card-title">
              <h3>
                {step === 1 && "Organization Details"}
                {step === 2 && "User Details"}
                {step === 3 && "Network Details"}
              </h3>
            </div>
          </div>

          <div className="row">
            {step === 1 && (
              <>
                <div className="col-lg-6">
                  <label className="col-form-label">
                    Organization Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                    placeholder="Enter Organization Name"
                  />
                </div>
                <div className="col-lg-6">
                  <label className="col-form-label">
                    Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={orgAddress}
                    onChange={(e) => setOrgAddress(e.target.value)}
                    placeholder="Enter Address"
                  />
                </div>

                <div className="col-lg-4">
                  <label className="col-form-label">
                    Country<span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center">
                    {selectedOrg && (
                      <ReactCountryFlag
                        countryCode={selectedOrg.code}
                        svg
                        style={{
                          width: "1.5em",
                          height: "1.5em",
                          marginRight: "0.5em",
                        }}
                      />
                    )}
                    <select
                      className={`form-control ${orgCountry === "" ? "placeholder" : ""
                        }`}
                      value={orgCountry}
                      onChange={(e) => {
                        setOrgCountry(e.target.value);
                        setOrgState("");
                        setOrgCity("");
                      }}
                    >
                      <option value="">Select Country</option>
                      {countryOptions.map((c) => (
                        <option key={c.code} value={c.code}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-4">
                  <label className="col-form-label">
                    State<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={orgState}
                    onChange={(e) => setOrgState(e.target.value)}
                    placeholder="Enter State"
                  />
                </div>

                <div className="col-lg-4">
                  <label className="col-form-label">
                    City<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={orgCity}
                    onChange={(e) => setOrgCity(e.target.value)}
                    placeholder="Enter City"
                  />
                </div>
              </>
            )}
            {step === 2 && (
              <>
                <div className="col-lg-6">
                  <label className="col-form-label">
                    First Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder="Enter First Name"
                  />
                </div>
                <div className="col-lg-6">
                  <label className="col-form-label">
                    Last Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    placeholder="Enter Last Name"
                  />
                </div>
                <div className="col-lg-6">
                  <label className="col-form-label">
                    Username<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter Username"
                  />
                </div>
                <div className="col-lg-6">
                  <label className="col-form-label">
                    Email<span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Enter Email Address"
                  />
                  {emailError && <p className="text-danger">{emailError}</p>}
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label">
                    Password<span className="text-danger">*</span>
                  </label>
                  <div className="input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter Password"
                    />
                    <img
                      src={showPassword ? eyeIcon : eyeCloseIcon}
                      alt="toggle"
                      className="toggle-password"
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label">
                    Confirm Password<span className="text-danger">*</span>
                  </label>
                  <div className="input-wrapper">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm Password"
                    />
                    <img
                      src={showConfirmPassword ? eyeIcon : eyeCloseIcon}
                      alt="toggle"
                      className="toggle-password"
                      onClick={toggleConfirmPasswordVisibility}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label">
                    Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={userAddress}
                    onChange={(e) => setUserAddress(e.target.value)}
                    placeholder="Enter Address"
                  />
                </div>

                <div className="col-lg-2">
                  <label className="col-form-label">
                    Country<span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center">
                    {selectedUser && (
                      <ReactCountryFlag
                        countryCode={selectedUser.code}
                        svg
                        style={{
                          width: "1.5em",
                          height: "1.5em",
                          marginRight: "0.5em",
                        }}
                      />
                    )}
                    <select
                      className="form-control"
                      value={userCountry}
                      onChange={(e) => {
                        setUserCountry(e.target.value);
                        setUserState("");
                        setUserCity("");
                      }}
                    >
                      <option value="">Select Country</option>
                      {countryOptions.map((c) => (
                        <option key={c.code} value={c.code}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-lg-2">
                  <label className="col-form-label">
                    State<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={userState}
                    onChange={(e) => setUserState(e.target.value)}
                    placeholder="Enter State"
                  />
                </div>

                <div className="col-lg-2">
                  <label className="col-form-label">
                    City<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={userCity}
                    onChange={(e) => setUserCity(e.target.value)}
                    placeholder="Enter City"
                  />
                </div>
              </>
            )}
            {step === 3 && (
              <>
                <div className="col-lg-6">
                  <label className="col-form-label">
                    Network Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={networkName}
                    onChange={(e) => setNetworkName(e.target.value)}
                    placeholder="Enter Network Name"
                  />
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label">
                    Network Country<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={networkCountry}
                    onChange={(e) => setNetworkCountry(e.target.value)}
                  >
                    <option value="">Select Country</option>
                    {countryOptions.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label">
                    Device Limit<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={deviceLimit}
                    onChange={(e) => setDeviceLimit(e.target.value)}
                    placeholder="Enter Device Limit"
                  />
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label">
                    Network Location<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={networkLocation}
                    onChange={(e) => setNetworkLocation(e.target.value)}
                    placeholder="Enter Network Location"
                  />
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label">
                    Network Timezone<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={networkTimezone}
                    onChange={(e) => setNetworkTimezone(e.target.value)}
                  //  disabled={!timeZones.length}
                  >
                    <option value="">Select Timezone</option>
                    {timeZones.map((tz, idx) => (
                      <option key={idx} value={tz}>
                        {tz}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-6">
                  <label className="col-form-label">
                    Network Status<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={networkStatus}
                    onChange={(e) => setNetworkStatus(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>

                {/* <div className="col-lg-6">
        <label className="col-form-label">
          Dummy User Email<span className="text-danger">*</span>
        </label>
        <input
          type="email"
          className="form-control"
          value={dummyUserEmail}
          onChange={(e) => setDummyUserEmail(e.target.value)}
          placeholder="Enter Dummy User Email"
        />
      </div> */}
              </>
            )}

            <div className="col-lg-12 user-footer d-flex justify-content-between mt-4">
              <div>
                {step > 1 && (
                  <button
                    type="button"
                    className="btn btn-outline"
                    onClick={handleBack}
                  >
                    {localizationStrings?.back || "Back"}
                  </button>
                )}
              </div>

              <div className="d-flex gap-2">
                <button type="button" className="btn btn-outline">
                  {localizationStrings?.cancel || "Cancel"}
                </button>

                {step < 3 && (
                  <button
                    type="button"
                    className="text-btn primary-btn"
                    onClick={handleNext}
                    disabled={
                      (step === 1 && !isOrgFormValid) ||
                      (step === 2 && !isUserFormValid)
                    }
                  >
                    {localizationStrings?.next || "Next"}
                  </button>
                )}

                {step === 3 && (
                  <button
                    type="submit"
                    className="text-btn primary-btn"
                    onClick={handleSubmit}
                    disabled={!isNetworkFormValid}
                  >
                    {localizationStrings?.submit || "Submit"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={showSuccessModal}
          onHide={handleSuccessModalClose}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="inc-alert"
        >
          <span className="success-icon">
            <i className="icon done"></i>
          </span>
          <h3>{localizationStrings?.success}</h3>
          <p style={{ fontSize: "1.2em", fontWeight: "bold" }}>
            {localizationStrings?.newUserAddedSuccessfully}!
          </p>
          <Button onClick={handleSuccessModalClose}>
            {localizationStrings?.ok}
          </Button>
        </Modal>
      </div>
    </section>
  );
};

export default LicenseProfile;
